import Vue from "vue";
import Router from "vue-router";
import Index from "@/pages/index";
import myh5 from "@/pages/h5/index";
const u = navigator.userAgent;
const isAndroid = u.indexOf("Android") > -1; //如果输出结果是true就判定是android终端或者uc浏览器
const isiOS = u.indexOf("iPhone") > -1; //根据输出结果true或者false来判断ios终端
const ipad = u.indexOf("iPad") > -1;
Vue.use(Router);
let myrouter = {
  path: "/",
  name: "Index",
  component: Index
};
if (isAndroid || isiOS) {
  myrouter = {
    path: "/",
    name: "h5",
    component: myh5
  };
} else {
  myrouter = {
    path: "/",
    name: "Index",
    component: Index
  };
}

let routers = new Router({
  mode: "history",
  routes: [myrouter]
});

//main.js里面的代码
routers.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  if (to.name == "Index") {
    let head = document.getElementsByTagName("head");
    let meta = document.createElement("meta");
    meta.content = "width=device-width,initial-scale=1.0";
    meta.name = "viewport";
    head[0].appendChild(meta);
  } else if (to.name == "h5") {
    let head = document.getElementsByTagName("head");
    let meta = document.createElement("meta");
    meta.name = "viewport";
    meta.content =
      "width=device-width,initial-scale=1,maximum-scale=1,minimum-scale=1,user-scalable=no";
    head[0].appendChild(meta);
  }
  next();
});

export default routers;



// WEBPACK FOOTER //
// ./src/router/index.js